import AudioPlayer from './audio-player';

export default AudioPlayer;
